export default {
	title: 'Mein Profil',
	messages: {
		choose_plan: 'Plan wählen',
		unlock_immediately: 'Alle Funktionen sofort freischalten',
		current_subscription: 'Ihr aktuelles Abonnement'
	},
	language: {
		title: 'Sprache',
		description: 'Wählen Sie die Sprache der Benutzeroberfläche',
		languages: {
			de: 'Deutsch',
			en: 'Englisch',
			es: 'Spanisch',
			fr: 'Französisch',
			hi: 'Hindi',
			it: 'Italienisch',
			ja: 'Japanisch',
			pt: 'Portugiesisch',
			zh: 'Chinesisch (Mandarin)'
		}
	},
	theme: {
		title: 'Theme-Auswahl'
	},
	actions: {
		manage_subscription: 'Mein Abonnement verwalten'
	},
	api_access: {
	  title: "API-Zugang (MCP-Server)",
	  description: "Ermöglicht KI-Agenten (Claude, ChatGPT, usw.) den Zugriff auf Ihre Gerositus-Projekte über das Model Context Protocol. Das Token gewährt denselben Zugriff wie Sie — geheim halten.",
	  endpoint: "MCP-Endpoint-URL",
	  no_token: "Noch kein Token — generieren Sie eines, um den KI-Agentenzugriff zu aktivieren.",
	  default_token_name: "Standardtoken",
	  status_active: "Aktiv",
	  status_revoked: "Widerrufen",
	  created_at: "Erstellt am {{date}}",
	  last_used_at: "Zuletzt verwendet am {{date}}",
	  never_used: "Noch nie verwendet",
	  generate: "Token generieren",
	  regenerate: "Token erneuern",
	  revoke: "Token widerrufen",
	  copy: "Kopieren",
	  copied: "In Zwischenablage kopiert",
	  copy_failed: "Kopieren fehlgeschlagen",
	  config_example: "Beispiel einer MCP-Client-Konfiguration",
	  reveal_title: "Speichern Sie Ihr Token jetzt",
	  reveal_done: "Ich habe es gespeichert",
	  reveal_warning_title: "Dies ist das einzige Mal, dass dieses Token angezeigt wird",
	  reveal_warning_body: "Kopieren Sie es an einen sicheren Ort (Passwort-Manager). Wenn Sie es verlieren, müssen Sie es erneuern. Jeder mit diesem Token kann Ihre Projekte lesen.",
	  regenerate_confirm_title: "Zugriffstoken erneuern?",
	  regenerate_confirm_body: "Das aktuelle Token wird sofort widerrufen und ein neues ausgestellt. KI-Agenten mit dem alten Token müssen neu konfiguriert werden.",
	  revoke_confirm_title: "Zugriffstoken widerrufen?",
	  revoke_confirm_body: "KI-Agenten mit diesem Token verlieren den Zugriff. Sie können jederzeit ein neues generieren."
	}
};
